export default __webpack_public_path__ + "static/media/background.d89e163c.jpg";